import React from "react";

/** Mono eyebrow label with a numbered index — the editorial "section stamp". */
export const Eyebrow: React.FC<{
  index: string;
  children: React.ReactNode;
  className?: string;
}> = ({ index, children, className = "" }) => (
  <div
    className={`v2-reveal flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.22em] ${className}`}
  >
    <span className="opacity-60">{index}</span>
    <span className="h-px w-8 bg-teal" />
    <span>{children}</span>
  </div>
);

/** Display headline in the serif face. */
export const Display: React.FC<{
  children: React.ReactNode;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  delay?: number;
}> = ({ children, as = "h2", className = "", delay = 1 }) => {
  const Tag = as as any;
  return (
    <Tag
      className={`v2-reveal font-display font-normal leading-[0.95] tracking-[-0.02em] ${className}`}
      data-delay={String(delay)}
    >
      {children}
    </Tag>
  );
};

/** Splits a sentence into masked words for the staggered reveal. */
export const Words: React.FC<{ text: string; baseDelay?: number }> = ({
  text,
  baseDelay = 0,
}) => (
  <>
    {text.split(" ").map((w, i) => (
      <span className="v2-word" key={i}>
        <span style={{ transitionDelay: `${baseDelay + i * 0.045}s` }}>
          {w}
        </span>
        {i < text.split(" ").length - 1 ? " " : ""}
      </span>
    ))}
  </>
);

export const Arrow: React.FC<{ className?: string }> = ({ className = "" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`v2-arrow h-4 w-4 ${className}`}
    aria-hidden
  >
    <path d="M5 12h14M13 5l7 7-7 7" />
  </svg>
);
